import l10n from "diy/util/l10n";
import features = require("diy/util/features");

import Type from "../definitions/Type";
import {NotificationConfig} from "../definitions/Config";

export default {
    type: Type.CHAT,

    testId: "chat",
    trackingId: "ChatNotification",

    content: l10n("chat.greeting"),

    mainAction: {
        testId: "open-chat",
        label: l10n("chat.link"),
        onClick: () => {
            let contactUrl = features.getPayload<string>('chatNotification');
            window.open(contactUrl);
        }
    }

} as NotificationConfig;



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/toolbar/notificationNG/types/Chat.ts
 **/